<div class="component-container">
  <h2 _ngcontent-c6="" class="page-heading">Emergency Shutdown</h2>
  <app-response-text class="uk-text-center" [lambdaMessage]="formMessage" [lambdaError]="formError"></app-response-text>

  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around">
    <div class="form">
      <!--Form part-->
      <div class="row">
        <p>Select LOB</p>
        <select class="custom-select" [(ngModel)]="lobSelected" (ngModelChange)="filterQueues()" [disabled]="!isTelecom">
          <option selected>All LOBs</option>
          <option *ngFor="let lob of lobs" [ngValue]="lob[1]">{{lob[0]}}</option>
        </select>
      </div>
  
      <div class="row">
        <p>Select Group</p>
        <select class="custom-select" [(ngModel)]="groupSelected" (ngModelChange)="filterQueues()">
          <option selected>All Groups</option>
          <option *ngFor="let group of filteredGroups" [ngValue]="group">{{group.groupName}}</option>
        </select>
      </div>
  
      <div class="row">
        <p>Select Queue</p>
        <select class="custom-select" [(ngModel)]="queueSelected" (ngModelChange)="filterQueues()">
          <option selected>All Queues</option>
          <option *ngFor="let queue of filteredQueues" [ngValue]="queue">{{queue.queueName}}</option>
        </select>
      </div>
  
      <div class="row">
        <p>Start Date and Time</p>
        <input type="date" [(ngModel)]="startDate" [max]="maxStartDate" [min]="minStartDate" (focusout)="formValid = validate()" />
        <input type="time" [(ngModel)]="startTime" (focusout)="formValid = validate()" />
      </div>
  
      <div class="row">
        <p>End Date and Time</p>
        <input type="date" [disabled]="noEndTime" [(ngModel)]="endDate" [max]="maxEndDate" [min]="minEndDate" (focusout)="formValid = validate()" />
        <input type="time" [disabled]="noEndTime" [(ngModel)]="endTime" (focusout)="formValid = validate()" />
        <input type="checkbox" id="noEnd" width="5vw" [(ngModel)]="noEndTime" (ngModelChange)="setEndTime()" (focusout)="formValid = validate()" />
        <label for="noEnd">End not known</label>
      </div>
  
      <div class="row">
        <p>Emergency Messages <img src="../../../../assets/add-button.png" (click)="addMessage()" class="add-image"alt="+"></p>
  
        <div *ngFor="let message of shutdownMessages; let i = index" (mouseenter)="mouseIndex = i" (mouseleave)="mouseIndex = -1">
          <select class="custom-select" [(ngModel)]="message[0]" (ngModelChange)="formValid = validate()">
            <option *ngFor="let language of languages" [ngValue]="language[1]" [hidden]="isFiltered(language, message)">{{
              language[0] }}
            </option>
          </select>
          <input class="shutdownMessage" placeholder="Shutdown message" type="text" [(ngModel)]="message[1]"(focusout)="formValid = validate()" />
          <div class="divider"></div>
          <button mat-raised-button color="primary" [hidden]="mouseIndex != i" (click)="deleteMessage(i)">Delete</button>
        </div>
  
      </div>
  
      <span class="red">
        <button mat-raised-button color="primary" (click)="resetShutdown()" [routerLink]="['/closures']" [disabled]="progress > 1">Cancel</button>
        <!-- <div class="divider"></div> -->
        <button mat-raised-button color="primary" (click)="formatData()" [disabled]="(progress > 1) || !formValid">Continue</button>
      </span>
    </div>
  
  
    <div class="confirmation">
      <ng-container *ngIf="progress >= 2">
        <!--Is the confirmation part-->
        <div class="red" [hidden]="progress < 3">
          <p>{{message}}</p>
        </div>
  
        <div [hidden]="progress < 2">
  
          <div class="red">
            WARNING!<br />
            This shutdown will affect the following call queue(s)
          </div>
  
          <app-data-grid [(data)]="queueData.queues" (itemChange)="updateItem($event)" [(isValid)]="formValid"
            [formTemplate]="form" [viewTemplate]="target" [footerTemplate]="footer" [columnNames]="[
                'LOB',
                'Group',
                'Queue',
                'Message',
                'Start Date',
                'Start Time',
                'End Date',
                'End Time'
              ]" [spacing]="[1, 2, 2, 5, 2, 2, 2, 2, 0.6]" [itemsPerPage]="6" [objectBluePrint]="{ messageDuration: '' }"
            [allowEdit]="false" [allowAdd]="false" [allowDelete]="false">
          </app-data-grid>
  
          <ng-template #form let-queue>
            <td>{{ idMap.get(queue.queueId).LOB }}</td>
            <td>{{ idMap.get(queue.queueId).groupId }}</td>
            <td>{{ idMap.get(queue.queueId).queueName }}</td>
            <td>{{ queue.messageId }}</td>
            <td>{{ queue.messageDuration.messageStartDate }}</td>
            <td>{{ queue.messageDuration.messageStartTime }}</td>
            <td>{{ queue.messageDuration.messageEndDate }}</td>
            <td>{{ queue.messageDuration.messageEndTime }}</td>
          </ng-template>
  
          <ng-template #target let-queue>
            <td>{{ idMap.get(queue.queueId).LOB }}</td>
            <td>{{ idMap.get(idMap.get(queue.queueId).groupId).groupName }}</td>
            <td>{{ idMap.get(queue.queueId).queueName }}</td>
            <td>
              {{
              idMap.get(queue.messageId).message.msgText[
              idMap.get(queue.queueId).language
              ]
              }}
            </td>
            <td>{{ queue.messageDuration.messageStartDate }}</td>
            <td>{{ queue.messageDuration.messageStartTime }}</td>
            <td>{{ queue.messageDuration.messageEndDate }}</td>
            <td>{{ queue.messageDuration.messageEndTime }}</td>
          </ng-template>
  
          <ng-template #footer>
            <div class="banner">
              <span class="banner-item">All times are in EST (UTC -5)</span>
              <span class="banner-item">Time Format: Military Time</span>
            </div>
          </ng-template>
  
          Type "Shutdown" to confirm:<br />
  
          <input name="arn" class="d-form" type="text" [(ngModel)]="shutdownConfirmation" />
          <br />
          <br />
  
          <button mat-raised-button color="primary" (click)="resetShutdown()" [hidden]="progress == 3">Cancel</button>
  
          <div class="divider"></div>
  
          <button mat-raised-button color="accent" (click)="shutdownQueues()" [disabled]="!confirmed() || progress >=3">Activate Shutdown</button>
  
          <div class="divider"></div>
  
          <button mat-raised-button color="primary" [hidden]="progress < 3" [routerLink]="[getClosureRoute()]">Continue</button>
  
        </div>
  
      </ng-container>
    </div>

  </div>
</div>
